/**
 * CargoWare X 系统品牌生效工具（favicon / 默认常量）
 */

export const DEFAULT_TITLE_SUFFIX = 'CargoWare X'
export const DEFAULT_FAVICON = '/favicon.png'

/**
 * 更新浏览器标签页 favicon
 */
export function applyFavicon(url: string = DEFAULT_FAVICON): void {
  const href = url || DEFAULT_FAVICON
  let link = document.querySelector<HTMLLinkElement>("link[rel*='icon']")
  if (!link) {
    link = document.createElement('link')
    link.rel = 'icon'
    document.head.appendChild(link)
  }
  link.type = href.endsWith('.svg') ? 'image/svg+xml' : 'image/png'
  link.href = href
}
